export enum TransactionStatus {
  Open = 0,
  Aborted = 11,
  Finished = 12,
  SystemClosed = 13,
}
